import { makeStyles, Tab, TabProps, Tabs } from "@material-ui/core";
import { useHistory } from "react-router";

import { NavTabs } from "@/common/components/LiveUnitNav/LiveUnitNavTabs/types";
import * as FullStory from "@/utilities/hooks/fullstory";


const useStyles = makeStyles((theme) => ({
    root: {
        textTransform: "none",
        minHeight: "2.9em",
        paddingTop: "1.5em",
    },
    tab: {
        color: theme.palette.text.primary,
        fontFamily: "Source Sans Pro",
        fontSize: theme.typography.body2.fontSize,
        fontWeight: 600,
        letterSpacing: ".03rem",
        lineHeight: "1rem",
        minHeight: "2.9em",
        textTransform: "none",
        minWidth: "auto",
        width: "7em",
    },
    flexContainerTabs: {
        justifyContent: "space-evenly",
    },
    textColorInherit: {
        opacity: 0.8,
    },
    ripple: {
        color: theme.palette.secondary.main,
    },
}));

export interface LiveUnitNavTabsProps {
    historyUrl: string | null;
    streamUrl: string | null;
    value: NavTabs;
    onRequestedVideo?: boolean;
}

const LabelTab: React.FC<TabProps> = (props) => {
    const classes = useStyles();

    return (
        <Tab
            classes={{
                root: classes.tab,
                textColorInherit: classes.textColorInherit,
            }}
            TouchRippleProps={{ className: classes.ripple }}
            {...props}
        />
    );
};

const LiveUnitNavTabs: React.FC<LiveUnitNavTabsProps> = ({ value, streamUrl, historyUrl, onRequestedVideo }) => {
    const classes = useStyles();
    const history = useHistory();


    const handleChange = (_: any, index: number) => {
        if (value != null && value == index && !onRequestedVideo) {
            return;
        }

        if (index == NavTabs.Stream && streamUrl) {
            history.push(streamUrl);
        } else if (index == NavTabs.History && historyUrl) {
            history.push(historyUrl);
        }
    };

    return (
        <Tabs
            classes={{
                root: classes.root,
                flexContainer: classes.flexContainerTabs,
            }}
            onChange={handleChange}
            value={value}
        >
            <LabelTab className={FullStory.names.classes.navigation.cameras} label="Cameras" disabled={!streamUrl} />
            <LabelTab className={FullStory.names.classes.navigation.history} label="History" disabled={!historyUrl} />
            {/* <LabelTab label="Events" disabled />
            <LabelTab label="Settings" disabled /> */}
        </Tabs>
    );
};

export default LiveUnitNavTabs;
